import React from 'react';

import {
  SvgWrapper,
  SvgWrapperProps,
} from 'components/svgs/SvgWrapper/SvgWrapper';

interface ProductVideoFilledSvgProps
  extends Omit<SvgWrapperProps, 'children'> {}

export const ProductVideoFilledSvg = ({
  ...svgProps
}: ProductVideoFilledSvgProps) => (
  <SvgWrapper viewBox="0 0 18 18" {...svgProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.562 1.518a2 2 0 0 0-2.45 1.414L.077 6.796a2 2 0 0 0 1.414 2.45l9.77 2.617a2 2 0 0 0 2.144-.769l3.324-4.65a1 1 0 0 0-.555-1.547L3.562 1.517ZM17.694 7.408a.5.5 0 0 1 .117.698l-2.485 3.475a.5.5 0 0 1-.813-.581l2.484-3.476a.5.5 0 0 1 .697-.116ZM5 11.25v2.25A2.5 2.5 0 0 1 2.5 16H0v-1h2.5A1.5 1.5 0 0 0 4 13.5V11l1 .25Z"
    />
  </SvgWrapper>
);
